import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Announce } from './model/announce';

@Injectable({
  providedIn: 'root'
})
export class AnnounceService {
  constructor(private http: HttpClient) {}

  markAsRead(n: Announce): Observable<any> {
    return this.http.patch('/api/announce/markAsRead/' + n.id, null);
  }
}
